{
    "(save {highestYearlyDiscount}%)": "({highestYearlyDiscount}% ਬਚਾਓ)",
    "{amount} days free": "{amount} ਦਿਨ ਮੁਫ਼ਤ",
    "{amount} off": "{amount} ਦੀ ਛੋਟ",
    "{amount} off for first {number} months.": "ਪਹਿਲੇ {number} ਮਹੀਨਿਆਂ ਲਈ {amount} ਦੀ ਛੋਟ।",
    "{amount} off for first {period}.": "ਪਹਿਲੀ {period} ਲਈ {amount} ਦੀ ਛੋਟ।",
    "{amount} off forever.": "ਹਮੇਸ਼ਾ ਲਈ {amount} ਦੀ ਛੋਟ।",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a {duration}-year {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% ਛੋਟ",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} ਨੂੰ ਹੁਣ {newsletterName} ਖ਼ਬਰਨਾਮਾ ਨਹੀਂ ਮਿਲੇਗਾ।",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "ਜਦੋਂ ਕੋਈ ਤੁਹਾਡੀਆਂ ਟਿੱਪਣੀਆਂ ਦਾ ਜਵਾਬ ਦੇਵੇਗਾ ਤਾਂ {memberEmail} ਨੂੰ ਹੁਣ ਈਮੇਲ ਪ੍ਰਾਪਤ ਨਹੀਂ ਹੋਵੇਗੀ।",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} ਨੂੰ ਹੁਣ ਇਹ ਖ਼ਬਰਨਾਮਾ ਨਹੀਂ ਮਿਲੇਗਾ।",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} ਦਿਨ ਮੁਫ਼ਤ",
    "{years} years": "",
    "+1 (123) 456-7890": "+1 (123) 456-7890",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "ਖਾਤਾ",
    "Account details updated successfully": "ਖਾਤੇ ਦੇ ਵੇਰਵੇ ਸਫਲਤਾਪੂਰਵਕ ਅੱਪਡੇਟ ਕੀਤੇ ਗਏ",
    "Account settings": "ਖਾਤਾ ਸੈਟਿੰਗਾਂ",
    "Add a personal note": "ਇੱਕ ਨਿੱਜੀ ਨੋਟ ਸ਼ਾਮਲ ਕਰੋ",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "ਮੁਫ਼ਤ ਅਜ਼ਮਾਇਸ਼ ਖਤਮ ਹੋਣ ਤੋਂ ਬਾਅਦ, ਤੁਹਾਡੇ ਵੱਲੋਂ ਚੁਣੇ ਗਏ ਟੀਅਰ ਲਈ ਤੁਹਾਡੇ ਤੋਂ ਨਿਯਮਤ ਕੀਮਤ ਲਈ ਜਾਵੇਗੀ। ਤੁਸੀਂ ਹਮੇਸ਼ਾ ਇਸ ਤੋਂ ਪਹਿਲਾਂ ਰੱਦ ਕਰ ਸਕਦੇ ਹੋ।",
    "Already a member?": "ਪਹਿਲਾਂ ਤੋਂ ਹੀ ਮੈਂਬਰ ਹੋ?",
    "An error occurred": "ਇੱਕ ਗਲਤੀ ਹੋਈ",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "ਇੱਕ ਅਚਾਨਕ ਗਲਤੀ ਹੋਈ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਜੇ ਗਲਤੀ ਬਣੀ ਰਹਿੰਦੀ ਹੈ ਤਾਂ <a>ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ</a>।",
    "Back": "ਪਿੱਛੇ",
    "Back to Log in": "ਲੌਗ ਇਨ 'ਤੇ ਵਾਪਸ ਜਾਓ",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "ਭਾਰੀ ਛੋਟ",
    "Bluesky": "",
    "Cancel anytime.": "ਕਿਸੇ ਵੀ ਸਮੇਂ ਰੱਦ ਕਰੋ।",
    "Cancel subscription": "ਸਦੱਸਤਾ ਰੱਦ ਕਰੋ",
    "Canceled": "",
    "Cancellation reason": "ਰੱਦ ਕਰਨ ਦਾ ਕਾਰਨ",
    "Change": "ਬਦਲੋ",
    "Change plan": "ਮੈਂਬਰਸ਼ਿਪ ਪਲਾਨ ਬਦਲੋ",
    "Check spam & promotions folders": "ਫਾਲਤੂ ਈਮੇਲ, ਸਪੈਮ ਅਤੇ ਪ੍ਰੋਮੋਸ਼ਨ ਫੋਲਡਰਾਂ ਦੀ ਜਾਂਚ ਕਰੋ",
    "Check with your mail provider": "ਆਪਣੇ ਮੇਲ ਪ੍ਰਦਾਤਾ ਨਾਲ ਜਾਂਚ ਕਰੋ",
    "Check your inbox to verify email update": "ਈਮੇਲ ਅੱਪਡੇਟ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਲਈ ਆਪਣਾ ਇਨਬਾਕਸ ਚੈੱਕ ਕਰੋ",
    "Choose": "ਚੁਣੋ",
    "Choose a different plan": "ਵੱਖਰਾ ਪਲਾਨ ਚੁਣੋ",
    "Choose a plan": "ਇੱਕ ਪਲਾਨ ਚੁਣੋ",
    "Choose a tier": "",
    "Choose your newsletters": "ਆਪਣੇ ਖ਼ਬਰਨਾਮੇ ਚੁਣੋ",
    "Click here to retry": "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰਨ ਲਈ ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "ਬੰਦ ਕਰੋ",
    "Code": "",
    "Comment preferences updated.": "ਟਿੱਪਣੀ ਤਰਜੀਹਾਂ ਅੱਪਡੇਟ ਕੀਤੀਆਂ ਗਈਆਂ।",
    "Comments": "ਟਿੱਪਣੀਆਂ",
    "Complimentary": "ਮੁਫ਼ਤ",
    "Confirm": "ਪੁਸ਼ਟੀ ਕਰੋ",
    "Confirm cancellation": "ਰੱਦ ਕਰਨ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
    "Confirm subscription": "ਸਦੱਸਤਾ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
    "Contact support": "ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    "Continue": "ਜਾਰੀ ਰੱਖੋ",
    "Continue subscription": "ਸਦੱਸਤਾ ਜਾਰੀ ਰੱਖੋ",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "ਸਟਰਾਈਪ (Stripe) ਚੈੱਕਆਉਟ ਸੈਸ਼ਨ ਨਹੀਂ ਬਣਾਇਆ ਜਾ ਸਕਿਆ",
    "Could not sign in. Login link expired.": "ਸਾਈਨ-ਇਨ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਿਆ। ਲੌਗਇਨ ਲਿੰਕ ਦੀ ਮਿਆਦ ਪੁੱਗ ਗਈ ਹੈ।",
    "Could not update email! Invalid link.": "ਈਮੇਲ ਅੱਪਡੇਟ ਨਹੀਂ ਕੀਤੀ ਜਾ ਸਕੀ! ਅਵੈਧ ਲਿੰਕ।",
    "Create a new contact": "ਨਵਾਂ ਸੰਪਰਕ ਬਣਾਓ",
    "Current plan": "ਮੌਜੂਦਾ ਯੋਜਨਾ",
    "Delete account": "ਖਾਤਾ ਮਿਟਾਓ",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "ਕੀ ਇਹ ਗਲਤੀ ਨਾਲ ਹੋਇਆ? ਆਪਣੀਆਂ ਤਰਜੀਹਾਂ ਦਾ ਪ੍ਰਬੰਧਨ <button>ਇੱਥੇ</button> ਕਰੋ।",
    "Don't have an account?": "ਕੀ ਤੁਹਾਡਾ ਖਾਤਾ ਨਹੀਂ ਹੈ?",
    "Edit": "ਸੰਪਾਦਿਤ ਕਰੋ",
    "Email": "ਈਮੇਲ",
    "Email confirmation link expired.": "",
    "Email it to them now": "",
    "Email newsletter": "ਈਮੇਲ ਖ਼ਬਰਨਾਮਾ",
    "Email newsletter settings updated": "ਈਮੇਲ ਖ਼ਬਰਨਾਮਾ ਸੈਟਿੰਗਾਂ ਅੱਪਡੇਟ ਕੀਤੀਆਂ ਗਈਆਂ",
    "Email preferences": "ਈਮੇਲ ਤਰਜੀਹਾਂ",
    "Email preferences updated.": "ਈਮੇਲ ਤਰਜੀਹਾਂ ਅੱਪਡੇਟ ਕੀਤੀਆਂ ਗਈਆਂ।",
    "Emails": "ਈਮੇਲਾਂ",
    "Emails disabled": "ਈਮੇਲਾਂ ਅਸਮਰੱਥ ਕੀਤੀਆਂ ਗਈਆਂ",
    "Ends {offerEndDate}": "{offerEndDate} ਨੂੰ ਸਮਾਪਤ ਹੁੰਦਾ ਹੈ",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "ਆਪਣਾ ਈਮੇਲ ਪਤਾ ਦਰਜ ਕਰੋ",
    "Enter your name": "ਆਪਣਾ ਨਾਮ ਦਰਜ ਕਰੋ",
    "Error": "ਗਲਤੀ",
    "Expires {expiryDate}": "{expiryDate} ਨੂੰ ਮਿਆਦ ਪੁੱਗਦੀ ਹੈ",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "ਸਦੱਸਤਾ ਰੱਦ ਕਰਨ ਵਿੱਚ ਅਸਫਲ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "Failed to log in, please try again": "ਲੌਗ ਇਨ ਕਰਨ ਵਿੱਚ ਅਸਫਲ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "Failed to log out, please try again": "ਲੌਗ ਆਊਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "ਚੈੱਕਆਉਟ ਦੀ ਪ੍ਰਕਿਰਿਆ ਕਰਨ ਵਿੱਚ ਅਸਫਲ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "Failed to send magic link email": "ਮੈਜਿਕ ਲਿੰਕ ਈਮੇਲ ਭੇਜਣ ਵਿੱਚ ਅਸਫਲ",
    "Failed to send verification email": "ਤਸਦੀਕ ਈਮੇਲ ਭੇਜਣ ਵਿੱਚ ਅਸਫਲ",
    "Failed to sign up, please try again": "ਸਾਈਨ ਅੱਪ ਕਰਨ ਵਿੱਚ ਅਸਫਲ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "Failed to update account data": "ਖਾਤਾ ਡਾਟਾ ਅੱਪਡੇਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    "Failed to update account details": "ਖਾਤੇ ਦੇ ਵੇਰਵੇ ਅੱਪਡੇਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "ਖ਼ਬਰਨਾਮਾ ਸੈਟਿੰਗਾਂ ਅੱਪਡੇਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    "Failed to update subscription, please try again": "ਸਦੱਸਤਾ ਅੱਪਡੇਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "Failed to verify code, please try again": "",
    "Forever": "ਹਮੇਸ਼ਾ ਲਈ",
    "Free Trial – Ends {trialEnd}": "ਮੁਫ਼ਤ ਅਜ਼ਮਾਇਸ਼ ਸਦੱਸਤਾ – {trialEnd} ਨੂੰ ਸਮਾਪਤ ਹੁੰਦੀ ਹੈ",
    "From": "",
    "Get help": "ਮਦਦ ਲਓ",
    "Get in touch for help": "ਮਦਦ ਲਈ ਸੰਪਰਕ ਕਰੋ",
    "Get notified when someone replies to your comment": "ਜਦੋਂ ਕੋਈ ਤੁਹਾਡੀ ਟਿੱਪਣੀ ਦਾ ਜਵਾਬ ਦੇਵੇ ਤਾਂ ਸੂਚਨਾ ਪ੍ਰਾਪਤ ਕਰੋ",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "ਇਸ ਪੋਸਟ 'ਤੇ ਸੁਝਾਅ ਦਿਓ",
    "Help! I'm not receiving emails": "ਮਦਦ! ਮੈਨੂੰ ਈਮੇਲਾਂ ਨਹੀਂ ਮਿਲ ਰਹੀਆਂ",
    "Here are a few other sites you may enjoy.": "ਇੱਥੇ ਕੁਝ ਹੋਰ ਸਾਈਟਾਂ ਹਨ ਜਿਨ੍ਹਾਂ ਦਾ ਤੁਸੀਂ ਆਨੰਦ ਲੈ ਸਕਦੇ ਹੋ।",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "ਜੇਕਰ ਕਿਸੇ ਖ਼ਬਰਨਾਮੇ ਨੂੰ ਫਾਲਤੂ ਈਮੇਲ ਸਪੈਮ ਵਜੋਂ ਫਲੈਗ ਕੀਤਾ ਜਾਂਦਾ ਹੈ, ਤਾਂ ਉਸ ਪਤੇ ਲਈ ਈਮੇਲਾਂ ਸਵੈਚਲਿਤ ਤੌਰ 'ਤੇ ਅਸਮਰੱਥ ਹੋ ਜਾਂਦੀਆਂ ਹਨ ਤਾਂ ਜੋ ਇਹ ਯਕੀਨੀ ਬਣਾਇਆ ਜਾ ਸਕੇ ਕਿ ਤੁਹਾਨੂੰ ਕੋਈ ਅਣਚਾਹੇ ਸੁਨੇਹੇ ਨਾ ਮਿਲਣ।",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "ਜੇਕਰ ਫਾਲਤੂ ਈਮੇਲ ਸਪੈਮ ਸ਼ਿਕਾਇਤ ਗਲਤੀ ਨਾਲ ਹੋਈ ਸੀ, ਜਾਂ ਤੁਸੀਂ ਦੁਬਾਰਾ ਈਮੇਲਾਂ ਪ੍ਰਾਪਤ ਕਰਨਾ ਸ਼ੁਰੂ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ, ਤਾਂ ਤੁਸੀਂ ਪਿਛਲੀ ਸਕ੍ਰੀਨ 'ਤੇ ਬਟਨ 'ਤੇ ਕਲਿੱਕ ਕਰਕੇ ਈਮੇਲਾਂ ਲਈ ਮੁੜ ਸਦੱਸਤਾ ਲੈ ਸਕਦੇ ਹੋ।",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "ਜੇਕਰ ਤੁਸੀਂ ਹੁਣ ਆਪਣੀ ਸਦੱਸਤਾ ਰੱਦ ਕਰਦੇ ਹੋ, ਤਾਂ ਤੁਹਾਡੇ ਕੋਲ {periodEnd} ਤੱਕ ਪਹੁੰਚ ਜਾਰੀ ਰਹੇਗੀ।",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "ਜੇਕਰ ਤੁਹਾਡੇ ਕੋਲ ਕਾਰਪੋਰੇਟ ਜਾਂ ਸਰਕਾਰੀ ਈਮੇਲ ਖਾਤਾ ਹੈ, ਤਾਂ ਆਪਣੇ IT ਵਿਭਾਗ ਨਾਲ ਸੰਪਰਕ ਕਰੋ ਅਤੇ ਉਹਨਾਂ ਨੂੰ {senderEmail} ਤੋਂ ਈਮੇਲਾਂ ਪ੍ਰਾਪਤ ਕਰਨ ਦੀ ਇਜਾਜ਼ਤ ਦੇਣ ਲਈ ਕਹੋ।",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "ਤੁਹਾਡੇ ਇਨਬਾਕਸ ਵਿੱਚ ਇੱਕ ਲੌਗਇਨ ਲਿੰਕ ਭੇਜਿਆ ਗਿਆ ਹੈ। ਜੇਕਰ ਇਹ 3 ਮਿੰਟਾਂ ਵਿੱਚ ਨਹੀਂ ਆਉਂਦਾ, ਤਾਂ ਆਪਣੇ ਫਾਲਤੂ ਈਮੇਲ (spam) ਦੀ ਜਾਂਚ ਕਰਨਾ ਯਕੀਨੀ ਬਣਾਓ।",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "ਜੇਕਰ ਤੁਸੀਂ ਦੁਬਾਰਾ ਈਮੇਲਾਂ ਪ੍ਰਾਪਤ ਕਰਨਾ ਸ਼ੁਰੂ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ, ਤਾਂ ਸਭ ਤੋਂ ਵਧੀਆ ਅਗਲੇ ਕਦਮ ਹਨ ਕਿ ਕਿਸੇ ਵੀ ਮੁੱਦੇ ਲਈ ਫਾਈਲ 'ਤੇ ਆਪਣੇ ਈਮੇਲ ਪਤੇ ਦੀ ਜਾਂਚ ਕਰੋ ਅਤੇ ਫਿਰ ਪਿਛਲੀ ਸਕ੍ਰੀਨ 'ਤੇ ਮੁੜ ਸਦੱਸਤਾ 'ਤੇ ਕਲਿੱਕ ਕਰੋ।",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "ਜੇਕਰ ਤੁਹਾਨੂੰ ਉਹ ਈਮੇਲ ਖ਼ਬਰਨਾਮਾ ਨਹੀਂ ਮਿਲ ਰਿਹਾ ਜਿਸਦੀ ਤੁਸੀਂ ਸਦੱਸਤਾ ਲਈ ਹੈ, ਤਾਂ ਇੱਥੇ ਕੁਝ ਚੀਜ਼ਾਂ ਹਨ ਜਿਨ੍ਹਾਂ ਦੀ ਜਾਂਚ ਕਰਨੀ ਹੈ।",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "ਜੇਕਰ ਤੁਸੀਂ ਇਹ ਸਾਰੀਆਂ ਜਾਂਚਾਂ ਪੂਰੀਆਂ ਕਰ ਲਈਆਂ ਹਨ ਅਤੇ ਤੁਹਾਨੂੰ ਅਜੇ ਵੀ ਈਮੇਲਾਂ ਨਹੀਂ ਮਿਲ ਰਹੀਆਂ, ਤਾਂ ਤੁਸੀਂ {supportAddress} 'ਤੇ ਸੰਪਰਕ ਕਰਕੇ ਸਹਾਇਤਾ ਪ੍ਰਾਪਤ ਕਰ ਸਕਦੇ ਹੋ।",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "ਜੇਕਰ ਖ਼ਬਰਨਾਮਾ ਭੇਜਣ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰਦੇ ਸਮੇਂ ਸਥਾਈ ਅਸਫਲਤਾ ਪ੍ਰਾਪਤ ਹੁੰਦੀ ਹੈ, ਤਾਂ ਖਾਤੇ 'ਤੇ ਈਮੇਲਾਂ ਅਸਮਰੱਥ ਕਰ ਦਿੱਤੀਆਂ ਜਾਣਗੀਆਂ।",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "ਆਪਣੇ ਈਮੇਲ ਕਲਾਇੰਟ ਵਿੱਚ {senderEmail} ਨੂੰ ਆਪਣੀ ਸੰਪਰਕ ਸੂਚੀ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰੋ। ਇਹ ਤੁਹਾਡੇ ਮੇਲ ਪ੍ਰਦਾਤਾ ਨੂੰ ਸੰਕੇਤ ਦਿੰਦਾ ਹੈ ਕਿ ਇਸ ਪਤੇ ਤੋਂ ਭੇਜੀਆਂ ਗਈਆਂ ਈਮੇਲਾਂ 'ਤੇ ਭਰੋਸਾ ਕੀਤਾ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ।",
    "Invalid email address": "ਅਵੈਧ ਈਮੇਲ ਪਤਾ",
    "Invalid verification code": "",
    "Jamie Larson": "ਫਲਾਣਾ ਫਲਾਣੀ",
    "jamie@example.com": "jamie@example.com",
    "Less like this": "ਇਸ ਵਰਗੇ ਘੱਟ",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਈਮੇਲਾਂ ਗਲਤੀ ਨਾਲ ਤੁਹਾਡੇ ਇਨਬਾਕਸ ਦੇ ਸਪੈਮ ਜਾਂ ਪ੍ਰੋਮੋਸ਼ਨ ਫੋਲਡਰਾਂ ਵਿੱਚ ਨਾ ਜਾ ਰਹੀਆਂ ਹੋਣ। ਜੇਕਰ ਅਜਿਹਾ ਹੈ, ਤਾਂ \"ਸਪੈਮ ਵਜੋਂ ਮਾਰਕ ਨਾ ਕਰੋ\" ਅਤੇ/ਜਾਂ \"ਇਨਬਾਕਸ ਵਿੱਚ ਭੇਜੋ\" 'ਤੇ ਕਲਿੱਕ ਕਰੋ।",
    "Manage": "ਪ੍ਰਬੰਧਨ ਕਰੋ",
    "Maybe later": "ਸ਼ਾਇਦ ਬਾਅਦ ਵਿੱਚ",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "ਇਸ ਈਮੇਲ ਡੋਮੇਨ ਤੋਂ ਮੈਂਬਰਸ਼ਿਪ ਫਿਲਹਾਲ ਬੰਦ ਹੈ।",
    "Memberships unavailable, contact the owner for access.": "ਮੈਂਬਰਸ਼ਿਪਾਂ ਉਪਲਬਧ ਨਹੀਂ ਹਨ, ਪਹੁੰਚ ਲਈ ਸੰਚਾਲਕ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
    "month": "ਮਹੀਨਾ",
    "Monthly": "ਮਾਸਿਕ",
    "More like this": "ਇਸ ਵਰਗੇ ਹੋਰ",
    "More options": "",
    "Name": "ਨਾਮ",
    "Need more help? Contact support": "ਹੋਰ ਮਦਦ ਦੀ ਲੋੜ ਹੈ? ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "ਤੁਹਾਡੇ ਖਾਤੇ 'ਤੇ ਨਿਊਜ਼ਲੈਟਰ ਦੋ ਕਾਰਨਾਂ ਕਰਕੇ ਅਸਮਰੱਥ ਕੀਤੇ ਜਾ ਸਕਦੇ ਹਨ: ਪਿਛਲੀ ਈਮੇਲ ਨੂੰ ਸਪੈਮ ਵਜੋਂ ਮਾਰਕ ਕੀਤਾ ਗਿਆ ਸੀ, ਜਾਂ ਈਮੇਲ ਭੇਜਣ ਦੀ ਕੋਸ਼ਿਸ਼ ਦੇ ਨਤੀਜੇ ਵਜੋਂ ਸਥਾਈ ਅਸਫਲਤਾ (ਬਾਊਂਸ) ਹੋਈ ਸੀ।",
    "No member exists with this e-mail address.": "ਇਸ ਈ-ਮੇਲ ਪਤੇ ਨਾਲ ਕੋਈ ਮੈਂਬਰ ਮੌਜੂਦ ਨਹੀਂ ਹੈ।",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "ਈਮੇਲਾਂ ਪ੍ਰਾਪਤ ਨਹੀਂ ਹੋ ਰਹੀਆਂ?",
    "Now check your email!": "ਹੁਣ ਆਪਣੀ ਈਮੇਲ ਚੈੱਕ ਕਰੋ!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "ਮੁੜ ਸਦੱਸਤਾ ਲੈਣ ਤੋਂ ਬਾਅਦ, ਜੇਕਰ ਤੁਹਾਨੂੰ ਅਜੇ ਵੀ ਆਪਣੇ ਇਨਬਾਕਸ ਵਿੱਚ ਈਮੇਲਾਂ ਨਹੀਂ ਦਿਸਦੀਆਂ, ਤਾਂ ਆਪਣਾ ਸਪੈਮ ਫੋਲਡਰ ਚੈੱਕ ਕਰੋ। ਕੁਝ ਇਨਬਾਕਸ ਪ੍ਰਦਾਤਾ ਪਿਛਲੀਆਂ ਸਪੈਮ ਸ਼ਿਕਾਇਤਾਂ ਦਾ ਰਿਕਾਰਡ ਰੱਖਦੇ ਹਨ ਅਤੇ ਈਮੇਲਾਂ ਨੂੰ ਫਲੈਗ ਕਰਨਾ ਜਾਰੀ ਰੱਖਣਗੇ। ਜੇਕਰ ਅਜਿਹਾ ਹੁੰਦਾ ਹੈ, ਤਾਂ ਨਵੀਨਤਮ ਨਿਊਜ਼ਲੈਟਰ ਨੂੰ 'ਸਪੈਮ ਨਹੀਂ' ਵਜੋਂ ਮਾਰਕ ਕਰੋ ਤਾਂ ਜੋ ਇਸਨੂੰ ਤੁਹਾਡੇ ਪ੍ਰਾਇਮਰੀ ਇਨਬਾਕਸ ਵਿੱਚ ਵਾਪਸ ਭੇਜਿਆ ਜਾ ਸਕੇ।",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "ਸਥਾਈ ਅਸਫਲਤਾ (ਬਾਊਂਸ)",
    "Phone number": "ਫ਼ੋਨ ਨੰਬਰ",
    "Plan": "ਯੋਜਨਾ",
    "Plan checkout was cancelled.": "ਯੋਜਨਾ ਚੈੱਕਆਉਟ ਰੱਦ ਕਰ ਦਿੱਤਾ ਗਿਆ ਸੀ।",
    "Plan upgrade was cancelled.": "ਯੋਜਨਾ ਅੱਪਗਰੇਡ ਰੱਦ ਕਰ ਦਿੱਤਾ ਗਿਆ ਸੀ।",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "ਆਪਣੀ ਮੁਫ਼ਤ ਸਦੱਸਤਾ ਨੂੰ ਵਿਵਸਥਿਤ ਕਰਨ ਲਈ ਕਿਰਪਾ ਕਰਕੇ {supportAddress} 'ਤੇ ਸੰਪਰਕ ਕਰੋ।",
    "Please enter {fieldName}": "ਕਿਰਪਾ ਕਰਕੇ {fieldName} ਦਾਖਲ ਕਰੋ",
    "Please fill in required fields": "ਕਿਰਪਾ ਕਰਕੇ ਲੋੜੀਂਦੇ ਖੇਤਰ ਭਰੋ",
    "Podcasts": "",
    "Re-enable emails": "ਈਮੇਲਾਂ ਨੂੰ ਮੁੜ-ਸਮਰੱਥ ਕਰੋ",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "ਸਿਫ਼ਾਰਸ਼ਾਂ",
    "Redeem your gift": "",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "{price} 'ਤੇ ਨਵਿਆਇਆ ਜਾਵੇਗਾ।",
    "Resume subscription": "",
    "Retry": "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "Save": "ਸੁਰੱਖਿਅਤ ਕਰੋ",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "ਲੌਗਇਨ ਲਿੰਕ ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ...",
    "Sending...": "ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "ਸਾਰੇ ਦਿਖਾਓ",
    "Sign in": "ਸਾਈਨ ਇਨ ਕਰੋ",
    "Sign out": "ਸਾਈਨ ਆਊਟ ਕਰੋ",
    "Sign up": "ਸਾਈਨ ਅੱਪ ਕਰੋ",
    "Signup error: Invalid link": "ਸਾਈਨ-ਅੱਪ ਗਲਤੀ: ਅਵੈਧ ਲਿੰਕ",
    "Signups from this email domain are currently restricted.": "ਇਸ ਈਮੇਲ ਡੋਮੇਨ ਤੋਂ ਸਾਈਨ-ਅੱਪ ਵਰਤਮਾਨ ਵਿੱਚ ਪ੍ਰਤਿਬੰਧਿਤ ਹਨ।",
    "Something went wrong, please try again later.": "ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ, ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "ਮਾਫ਼ ਕਰਨਾ, ਇਸ ਵੇਲੇ ਕੋਈ ਸਿਫ਼ਾਰਸ਼ਾਂ ਉਪਲਬਧ ਨਹੀਂ ਹਨ।",
    "Sorry, that didn’t work.": "ਮਾਫ਼ ਕਰਨਾ, ਉਹ ਕੰਮ ਨਹੀਂ ਹੋਇਆ।",
    "Spam complaints": "ਸਪੈਮ ਸ਼ਿਕਾਇਤਾਂ",
    "Start {amount}-day free trial": "{amount}-ਦਿਨ ਦੀ ਮੁਫ਼ਤ ਅਜ਼ਮਾਇਸ਼ ਸਦੱਸਤਾ ਸ਼ੁਰੂ ਕਰੋ",
    "Starting {startDate}": "{startDate} ਤੋਂ ਸ਼ੁਰੂ",
    "Starting today": "ਅੱਜ ਤੋਂ ਸ਼ੁਰੂ",
    "Submit feedback": "ਸੁਝਾਅ ਜਮ੍ਹਾਂ ਕਰੋ",
    "Subscribe": "ਗਾਹਕ ਬਣੋ",
    "Subscribed": "ਸਦੱਸਤਾ ਲਈ ਗਈ",
    "Subscription plan updated successfully": "ਸਦੱਸਤਾ ਯੋਜਨਾ ਸਫਲਤਾਪੂਰਵਕ ਅੱਪਡੇਟ ਕੀਤੀ ਗਈ",
    "Success": "ਸਫਲ",
    "Success! Check your email for magic link to sign-in.": "ਸਫਲ! ਸਾਈਨ-ਇਨ ਕਰਨ ਲਈ ਮੈਜਿਕ ਲਿੰਕ ਲਈ ਆਪਣੀ ਈਮੇਲ ਦੇਖੋ।",
    "Success! Your account is fully activated, you now have access to all content.": "ਸਫਲ! ਤੁਹਾਡਾ ਖਾਤਾ ਪੂਰੀ ਤਰ੍ਹਾਂ ਸਰਗਰਮ ਹੋ ਗਿਆ ਹੈ, ਹੁਣ ਤੁਹਾਡੇ ਕੋਲ ਸਾਰੀ ਸਮੱਗਰੀ ਤੱਕ ਪਹੁੰਚ ਹੈ।",
    "Success! Your email is updated.": "ਸਫਲ! ਤੁਹਾਡੀ ਈਮੇਲ ਅੱਪਡੇਟ ਹੋ ਗਈ ਹੈ।",
    "Successfully unsubscribed": "ਸਫਲਤਾਪੂਰਵਕ ਸਦੱਸਤਾ ਰੱਦ ਕੀਤੀ ਗਈ",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "ਸਦੱਸਤਾ ਲੈਣ ਲਈ ਤੁਹਾਡਾ ਧੰਨਵਾਦ। ਪੜ੍ਹਨਾ ਸ਼ੁਰੂ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ, ਹੇਠਾਂ ਕੁਝ ਹੋਰ ਸਾਈਟਾਂ ਦਿੱਤੀਆਂ ਗਈਆਂ ਹਨ ਜਿਨ੍ਹਾਂ ਦਾ ਤੁਸੀਂ ਆਨੰਦ ਲੈ ਸਕਦੇ ਹੋ।",
    "Thank you for your support": "ਤੁਹਾਡੇ ਸਹਿਯੋਗ ਲਈ ਧੰਨਵਾਦ",
    "Thank you for your support!": "ਤੁਹਾਡੇ ਸਹਿਯੋਗ ਲਈ ਧੰਨਵਾਦ!",
    "Thanks for the feedback!": "ਸੁਝਾਅ ਲਈ ਧੰਨਵਾਦ!",
    "That didn't go to plan": "ਇਹ ਯੋਜਨਾ ਅਨੁਸਾਰ ਨਹੀਂ ਹੋਇਆ",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "ਸਾਡੇ ਕੋਲ ਤੁਹਾਡਾ ਈਮੇਲ ਪਤਾ {memberEmail} ਹੈ — ਜੇਕਰ ਇਹ ਸਹੀ ਨਹੀਂ ਹੈ, ਤਾਂ ਤੁਸੀਂ ਇਸਨੂੰ ਆਪਣੇ <button>ਖਾਤਾ ਸੈਟਿੰਗਾਂ ਖੇਤਰ</button> ਵਿੱਚ ਅੱਪਡੇਟ ਕਰ ਸਕਦੇ ਹੋ।",
    "There was a problem submitting your feedback. Please try again a little later.": "ਤੁਹਾਡਾ ਸੁਝਾਅ ਜਮ੍ਹਾਂ ਕਰਨ ਵਿੱਚ ਇੱਕ ਸਮੱਸਿਆ ਆਈ। ਕਿਰਪਾ ਕਰਕੇ ਥੋੜ੍ਹੀ ਦੇਰ ਬਾਅਦ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "There was an error cancelling your subscription, please try again.": "ਤੁਹਾਡੀ ਸਦੱਸਤਾ ਰੱਦ ਕਰਨ ਵਿੱਚ ਇੱਕ ਗਲਤੀ ਆਈ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "There was an error continuing your subscription, please try again.": "ਤੁਹਾਡੀ ਸਦੱਸਤਾ ਜਾਰੀ ਰੱਖਣ ਵਿੱਚ ਇੱਕ ਗਲਤੀ ਆਈ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "There was an error processing your payment. Please try again.": "ਤੁਹਾਡੇ ਭੁਗਤਾਨ ਦੀ ਪ੍ਰਕਿਰਿਆ ਕਰਨ ਵਿੱਚ ਇੱਕ ਗਲਤੀ ਆਈ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "There was an error sending the email, please try again": "ਈਮੇਲ ਭੇਜਣ ਵਿੱਚ ਇੱਕ ਗਲਤੀ ਆਈ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "ਇਹ ਸਾਈਟ ਸਿਰਫ਼ ਸੱਦਾ-ਪੱਤਰ 'ਤੇ ਹੈ, ਪਹੁੰਚ ਲਈ ਮਾਲਕ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
    "This site is not accepting donations at the moment.": "ਇਹ ਸਾਈਟ ਇਸ ਵੇਲੇ ਦਾਨ ਨਹੀਂ ਲੈ ਰਹੀ ਹੈ।",
    "This site is not accepting payments at the moment.": "ਇਹ ਸਾਈਟ ਇਸ ਸਮੇਂ ਭੁਗਤਾਨ ਸਵੀਕਾਰ ਨਹੀਂ ਕਰ ਰਹੀ ਹੈ।",
    "This site only accepts paid members.": "ਇਹ ਸਾਈਟ ਸਿਰਫ਼ ਭੁਗਤਾਨਸ਼ੁਦਾ ਮੈਂਬਰਾਂ ਨੂੰ ਸਵੀਕਾਰ ਕਰਦੀ ਹੈ।",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "ਸਾਈਨ-ਅੱਪ ਪੂਰਾ ਕਰਨ ਲਈ, ਆਪਣੇ ਇਨਬਾਕਸ ਵਿੱਚ ਪੁਸ਼ਟੀਕਰਨ ਲਿੰਕ 'ਤੇ ਕਲਿੱਕ ਕਰੋ। ਜੇਕਰ ਇਹ 3 ਮਿੰਟਾਂ ਦੇ ਅੰਦਰ ਨਹੀਂ ਆਉਂਦਾ, ਤਾਂ ਆਪਣਾ ਸਪੈਮ ਫੋਲਡਰ ਚੈੱਕ ਕਰੋ!",
    "To continue to stay up to date, subscribe to {publication} below.": "ਅੱਪ-ਟੂ-ਡੇਟ ਰਹਿਣ ਲਈ, ਹੇਠਾਂ {publication} ਦੀ ਸਦੱਸਤਾ ਲਓ।",
    "Too many attempts try again in {number} days.": "ਬਹੁਤ ਸਾਰੀਆਂ ਕੋਸ਼ਿਸ਼ਾਂ, {number} ਦਿਨਾਂ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "Too many attempts try again in {number} hours.": "ਬਹੁਤ ਸਾਰੀਆਂ ਕੋਸ਼ਿਸ਼ਾਂ, {number} ਘੰਟਿਆਂ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "Too many attempts try again in {number} minutes.": "ਬਹੁਤ ਸਾਰੀਆਂ ਕੋਸ਼ਿਸ਼ਾਂ, {number} ਮਿੰਟਾਂ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "Too many different sign-in attempts, try again in {number} days": "ਬਹੁਤ ਸਾਰੀਆਂ ਵੱਖ-ਵੱਖ ਸਾਈਨ-ਇਨ ਕੋਸ਼ਿਸ਼ਾਂ, {number} ਦਿਨਾਂ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "Too many different sign-in attempts, try again in {number} hours": "ਬਹੁਤ ਸਾਰੀਆਂ ਵੱਖ-ਵੱਖ ਸਾਈਨ-ਇਨ ਕੋਸ਼ਿਸ਼ਾਂ, {number} ਘੰਟਿਆਂ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "Too many different sign-in attempts, try again in {number} minutes": "ਬਹੁਤ ਸਾਰੀਆਂ ਵੱਖ-ਵੱਖ ਸਾਈਨ-ਇਨ ਕੋਸ਼ਿਸ਼ਾਂ, {number} ਮਿੰਟਾਂ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "Too many sign-up attempts, try again later": "ਬਹੁਤ ਸਾਰੀਆਂ ਸਾਈਨ-ਅੱਪ ਕੋਸ਼ਿਸ਼ਾਂ, ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "Try free for {amount} days, then {originalPrice}.": "{amount} ਦਿਨਾਂ ਲਈ ਮੁਫ਼ਤ ਅਜ਼ਮਾਓ, ਫਿਰ {originalPrice}।",
    "Unable to initiate checkout session": "ਚੈੱਕਆਉਟ ਸੈਸ਼ਨ ਸ਼ੁਰੂ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ",
    "Unlock access to all newsletters by becoming a paid subscriber.": "ਭੁਗਤਾਨਸ਼ੁਦਾ ਗਾਹਕ ਬਣ ਕੇ ਸਾਰੇ ਨਿਊਜ਼ਲੈਟਰਾਂ ਤੱਕ ਪਹੁੰਚ ਅਨਲੌਕ ਕਰੋ।",
    "Unsubscribe from all emails": "ਸਾਰੀਆਂ ਈਮੇਲਾਂ ਤੋਂ ਸਦੱਸਤਾ ਰੱਦ ਕਰੋ",
    "Unsubscribed": "ਸਦੱਸਤਾ ਰੱਦ ਕੀਤੀ ਗਈ",
    "Unsubscribed from all emails.": "ਸਾਰੀਆਂ ਈਮੇਲਾਂ ਤੋਂ ਸਦੱਸਤਾ ਰੱਦ ਕੀਤੀ ਗਈ।",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "ਈਮੇਲਾਂ ਤੋਂ ਸਦੱਸਤਾ ਰੱਦ ਕਰਨ ਨਾਲ {title} ਲਈ ਤੁਹਾਡੀ ਭੁਗਤਾਨਸ਼ੁਦਾ ਸਦੱਸਤਾ ਰੱਦ ਨਹੀਂ ਹੋਵੇਗੀ।",
    "Update": "ਅੱਪਡੇਟ ਕਰੋ",
    "Update your preferences": "ਆਪਣੀਆਂ ਤਰਜੀਹਾਂ ਨੂੰ ਅੱਪਡੇਟ ਕਰੋ",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "ਤਸਦੀਕ ਲਿੰਕ ਭੇਜਿਆ ਗਿਆ, ਆਪਣਾ ਇਨਬਾਕਸ ਚੈੱਕ ਕਰੋ",
    "Verify your email address is correct": "ਪੁਸ਼ਟੀ ਕਰੋ ਕਿ ਤੁਹਾਡਾ ਈਮੇਲ ਪਤਾ ਸਹੀ ਹੈ",
    "Verifying...": "",
    "View plans": "ਯੋਜਨਾਵਾਂ ਦੇਖੋ",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "ਅਸੀਂ ਤੁਹਾਨੂੰ ਸਦੱਸਤਾ ਤੋਂ ਹਟਾ ਨਹੀਂ ਸਕੇ ਕਿਉਂਕਿ ਈਮੇਲ ਪਤਾ ਨਹੀਂ ਮਿਲਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਸਾਈਟ ਮਾਲਕ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "{name}, ਵਾਪਸ ਆਉਣ 'ਤੇ ਸੁਆਗਤ ਹੈ!",
    "Welcome back!": "ਵਾਪਸ ਆਉਣ 'ਤੇ ਸੁਆਗਤ ਹੈ!",
    "Welcome to {siteTitle}": "{siteTitle} 'ਤੇ ਸੁਆਗਤ ਹੈ",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "ਜਦੋਂ ਕੋਈ ਇਨਬਾਕਸ ਈਮੇਲ ਸਵੀਕਾਰ ਕਰਨ ਵਿੱਚ ਅਸਫਲ ਰਹਿੰਦਾ ਹੈ ਤਾਂ ਇਸਨੂੰ ਆਮ ਤੌਰ 'ਤੇ ਬਾਊਂਸ ਕਿਹਾ ਜਾਂਦਾ ਹੈ। ਕਈ ਮਾਮਲਿਆਂ ਵਿੱਚ, ਇਹ ਅਸਥਾਈ ਹੋ ਸਕਦਾ ਹੈ। ਹਾਲਾਂਕਿ, ਕੁਝ ਮਾਮਲਿਆਂ ਵਿੱਚ, ਜਦੋਂ ਕੋਈ ਈਮੇਲ ਪਤਾ ਅਵੈਧ ਜਾਂ ਮੌਜੂਦ ਨਾ ਹੋਵੇ ਤਾਂ ਇੱਕ ਬਾਊਂਸ ਹੋਈ ਈਮੇਲ ਨੂੰ ਸਥਾਈ ਅਸਫਲਤਾ ਵਜੋਂ ਵਾਪਸ ਕੀਤਾ ਜਾ ਸਕਦਾ ਹੈ।",
    "Why has my email been disabled?": "ਮੇਰੀ ਈਮੇਲ ਅਸਮਰੱਥ ਕਿਉਂ ਕੀਤੀ ਗਈ ਹੈ?",
    "X (Twitter)": "",
    "year": "ਸਾਲ",
    "Yearly": "ਸਾਲਾਨਾ",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "ਤੁਹਾਡੇ ਕੋਲ ਵਰਤਮਾਨ ਵਿੱਚ ਇੱਕ ਮੁਫਤ ਮੈਂਬਰਸ਼ਿਪ ਹੈ, ਪੂਰੀ ਪਹੁੰਚ ਲਈ ਇੱਕ ਭੁਗਤਾਨਸ਼ੁਦਾ ਸਦੱਸਤਾ ਵਿੱਚ ਅੱਪਗਰੇਡ ਕਰੋ।",
    "You have been successfully resubscribed": "ਤੁਹਾਨੂੰ ਸਫਲਤਾਪੂਰਵਕ ਮੁੜ-ਸਦੱਸਤਾ ਦਿੱਤੀ ਗਈ ਹੈ",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "ਤੁਸੀਂ ਵਰਤਮਾਨ ਵਿੱਚ ਈਮੇਲਾਂ ਪ੍ਰਾਪਤ ਨਹੀਂ ਕਰ ਰਹੇ ਹੋ",
    "You're not receiving emails": "ਤੁਹਾਨੂੰ ਈਮੇਲਾਂ ਨਹੀਂ ਮਿਲ ਰਹੀਆਂ",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "ਤੁਹਾਨੂੰ ਈਮੇਲਾਂ ਨਹੀਂ ਮਿਲ ਰਹੀਆਂ ਕਿਉਂਕਿ ਤੁਸੀਂ ਜਾਂ ਤਾਂ ਹਾਲੀਆ ਸੁਨੇਹੇ ਨੂੰ ਸਪੈਮ ਵਜੋਂ ਮਾਰਕ ਕੀਤਾ ਹੈ, ਜਾਂ ਕਿਉਂਕਿ ਸੁਨੇਹੇ ਤੁਹਾਡੇ ਦਿੱਤੇ ਗਏ ਈਮੇਲ ਪਤੇ 'ਤੇ ਨਹੀਂ ਪਹੁੰਚਾਏ ਜਾ ਸਕੇ।",
    "You've been gifted a {duration}-month {tierName} membership_one": "",
    "You've been gifted a {duration}-month {tierName} membership_other": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a {duration}-year {tierName} membership": "",
    "You've been gifted a {duration}-year {tierName} membership to {siteTitle}": "",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "ਤੁਸੀਂ ਸਫਲਤਾਪੂਰਵਕ ਸਾਈਨ ਇਨ ਕਰ ਲਿਆ ਹੈ।",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "ਤੁਸੀਂ ਸਫਲਤਾਪੂਰਵਕ ਸਦੱਸਤਾ ਲਈ ਹੈ: <strong>{siteTitle}</strong>",
    "Your account": "ਤੁਹਾਡਾ ਖਾਤਾ",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "ਤੁਹਾਡੀ ਈਮੇਲ ਮੁੜ-ਸਦੱਸਤਾ ਲੈਣ ਵਿੱਚ ਅਸਫਲ ਰਹੀ ਹੈ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "ਤੁਹਾਡਾ ਇਨਪੁਟ ਇਹ ਆਕਾਰ ਦੇਣ ਵਿੱਚ ਮਦਦ ਕਰਦਾ ਹੈ ਕਿ ਕੀ ਪ੍ਰਕਾਸ਼ਿਤ ਹੁੰਦਾ ਹੈ।",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "ਤੁਹਾਡੀ ਸਦੱਸਤਾ {expiryDate} ਨੂੰ ਮਿਆਦ ਪੁੱਗ ਜਾਵੇਗੀ।",
    "Your subscription will renew on {renewalDate}": "ਤੁਹਾਡੀ ਸਦੱਸਤਾ {renewalDate} ਨੂੰ ਨਵਿਆਈ ਜਾਵੇਗੀ।",
    "Your subscription will start on {subscriptionStart}": "ਤੁਹਾਡੀ ਸਦੱਸਤਾ {subscriptionStart} ਨੂੰ ਸ਼ੁਰੂ ਹੋਵੇਗੀ।"
}
